/**
 * Versions of the legal documents a couple accepted.
 *
 * Recorded alongside the timestamp because the timestamp alone is close to
 * worthless: when a policy changes you need to know who accepted WHICH text,
 * and "they agreed at some point" answers nothing in a complaint. Bump the
 * matching value whenever the corresponding page changes materially, and
 * update the "Last updated" line in that page to the same date.
 *
 * ISO dates rather than integers so a record is legible against the page it
 * refers to without a lookup table.
 */
export const LEGAL_VERSIONS = {
  privacy: '2026-08-16',
  terms: '2026-08-16',
};

/** The consent record written to a wedding document at creation. */
export const consentRecord = (acceptedAt) => ({
  privacyVersion: LEGAL_VERSIONS.privacy,
  termsVersion: LEGAL_VERSIONS.terms,
  acceptedAt,
  // How consent was given, so a later audit can tell an explicit tick from a
  // sign-in-wrap without inferring it from the date.
  method: 'signin-wrap',
});
